import {ArrowRightOutlined as AntdArrowRightOutlined} from '@ant-design/icons';

export default function ArrowRightOutlined(props) {
  return <AntdArrowRightOutlined {...props} />;
}
